import { connect } from 'react-redux'
import { IStore } from '../../../../../../reducers'
import {
  getFromDate,
  getToDate,
} from '../../../../../../reducers/bookingCalendar/selectors/dates'
import { ICalendarProps } from './Calendar'

const mapStateToProps = (state: IStore): ICalendarProps => ({
  finishDate: getToDate(state),
  startDate: getFromDate(state),
})

export default connect(mapStateToProps)
